export default "__VITE_ASSET__Cqontki6__"